import {
  TAG_FETCH_END,
  TAG_FETCH_MORE_END,
} from '../constants';

export default function runtime(state = {
  inited: false,
  column: [],
  banner: [],
  courses: [],
  subTag: [],
  serial: [],
}, action) {
  switch (action.type) {
    case TAG_FETCH_END:
      return {
        ...action.data,
        column: action.data.column || [],
        banner: action.data.banner || [],
        courses: action.data.courses || [],
        inited: true,
        hasMore: action.data.courses && action.data.courses.length >= 20,
        serial: action.data.serial || [],
      }
    case TAG_FETCH_MORE_END:
      return {
        ...state,
        courses: state.courses.concat(action.data.course),
        hasMore: action.data.course && action.data.course.length >= 10,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tag.js